// extracted by mini-css-extract-plugin
module.exports = {"loginRedirect":"loginRedirect-cuAMQ","header":"header-Ncdse","body":"body--0sFl","text":"text-pZx7S","button":"button-EWBPh"};